import store from '@/store';

export function rejectRequest(requestId, response = null) {
    return store.dispatch('requests/rejected', { id: requestId, response });
}

export default rejectRequest;
